const data={
    "code": 200,
    "time": 1505905228615,
    "desc": "´¦Àí³É¹¦",
    "end": true,
    "data": {
        "total": 29,
        "list": [
            {
                "taskId": 1,
                "parentId": 0,
                "actions": [],
                "platform": "",
                "taskName": "job4",
                "taskDescription": "",
                "url": "http://s.trafficjam.cn/s,CCla7nPCPX4wP4DDHC81,uuid=__UUID__",
                "targetPv": 200000,
                "pvToUvRatio": 50,
                "beginDate": 1503468000000,
                "endDate": 1503468000000,
                "timePairs": [
                    {
                        "beginTime": 900,
                        "endTime": 2359
                    }
                ],
                "createTime": 1503381600000,
                "lastModifyTime": 0,
                "filtration": [
                    "2017-08-25",
                    "2017-08-26",
                    "2017-08-27",
                    "2017-08-28",
                    "2017-08-30",
                    "2017-08-31",
                    "2017-09-02",
                    "2017-09-03",
                    "2017-09-04",
                    "2017-09-06",
                    "2017-09-07",
                    "2017-09-09",
                    "2017-09-10",
                    "2017-09-11",
                    "2017-09-13",
                    "2017-09-14",
                    "2017-09-16",
                    "2017-09-17",
                    "2017-09-18",
                    "2017-09-20",
                    "2017-09-21",
                    "2017-09-23",
                    "2017-09-24",
                    "2017-09-25",
                    "2017-09-27",
                    "2017-09-28"
                ],
                "subTasks": [
                    {
                        "taskId": 2,
                        "parentId": 1,
                        "actions": [],
                        "platform": "",
                        "taskName": "job5",
                        "taskDescription": "",
                        "url": "http://dol.deliver.ifeng.com/s?z=ifeng&c=1&l=58053",
                        "targetPv": 200000,
                        "pvToUvRatio": 30,
                        "beginDate": 1503468000000,
                        "endDate": 1503468000000,
                        "timePairs": [
                            {
                                "beginTime": 900,
                                "endTime": 2359
                            }
                        ],
                        "createTime": 1503381600000,
                        "lastModifyTime": 0,
                        "filtration": [
                        "2017-09-14",
                        "2017-09-16",
                        "2017-09-17",
                        "2017-09-18",
                        "2017-09-20",
                        "2017-09-21",
                        "2017-09-23",
                        "2017-09-24",
                        "2017-09-25",
                        "2017-09-27",
                        "2017-09-28"],
                        "subTasks": [],
                        "remainPv": 0,
                        "finishedPv": 0,
                        "ipReusedTimes": 10,
                        "waitTimeout": 0,
                        "status": 0,
                        "taskType": "EV",
                        "scriptPath": "",
                        "taskPosition": "DEFAULT",
                        "referer": "http://www.ifeng.com/",
                        "finishedFlag": "",
                        "beginDateStr": "2017-08-23 14:00:00",
                        "endDateStr": "2017-08-23 14:00:00",
                        "createTimeStr": "2017-08-22 14:00:00",
                        "deviceInfo": "",
                        "requestType": ""
                    }
                ],
                "remainPv": 0,
                "finishedPv": 0,
                "ipReusedTimes": 10,
                "waitTimeout": 0,
                "status": 0,
                "taskType": "EV",
                "scriptPath": "",
                "taskPosition": "DEFAULT",
                "referer": "http://www.ifeng.com/",
                "finishedFlag": "",
                "beginDateStr": "2017-08-23 14:00:00",
                "endDateStr": "2017-08-23 14:00:00",
                "createTimeStr": "2017-08-22 14:00:00",
                "deviceInfo": "",
                "requestType": ""
            },
            
        ]
    },
    "success": true
}
export default data;



// WEBPACK FOOTER //
// ./pages/task/tasklist/data.js